import { setCookie } from 'nookies'

type CreateParams = {
  key: string
  value: any
}

export function createCookie({ key, value }: CreateParams): boolean {
  if (!key || !value) return false

  setCookie(undefined, key, value, {
    maxAge: 60 * 60 * 24 * 30 * 12,
    path: '/',
  })

  return true
}
